<div class="remind-me-later-pop-up">
    <div class="remind-me-later-info">
        <div class="remind-me-later-text" [innerHTML]="remindMeLaterMessages.info"></div>
        <i class="theme-ex" (click)="closeReminderMeLater()"></i>
    </div>
    @if (undoTimer > 0) {
        <div class="undo-remind-me-later" (click)="undoReminderMeLater()">
            {{ remindMeLaterMessages.undo }}
            <span>&lpar;</span>
            <ms-countdown-timer
                [timeInSeconds]="undoTimer"
                [showTimerInSeconds]="true"
                [isSports]="true"
                (finish)="closeReminderMeLater()"></ms-countdown-timer>
            <span>&rpar;</span>
        </div>
    }
</div>
